import React from 'react';
import { Idea as IdeaType, MediaType } from '~/content/types';

import MovieIcon from '@bufferapp/ui/Icon/Icons/Movie';

const PlayIcon = () => (
  <div className="play_icon">
    <MovieIcon size="large" />
  </div>
);

export const useIdeaMedia = ({
  idea,
  mediaIndex = 0,
}: {
  idea: IdeaType;
  mediaIndex?: number;
}): { media?: JSX.Element } => {
  let media: JSX.Element | undefined;
  if (idea.content.media) {
    const src =
      idea.content.media[mediaIndex].thumbnailUrl ||
      idea.content.media[mediaIndex].url;
    media = (
      <div
        className="media"
        style={{
          backgroundImage: `url(${src})`,
        }}
      >
        {idea.content.media[mediaIndex].type === MediaType.video && (
          <PlayIcon />
        )}
      </div>
    );
  }

  return {
    media,
  };
};
